export enum DatasetConfigFilterEnum {
    ALL,
    INTERNAL,
    EXTERNAL,
    NRI,
 //   TENSORFLIGHT,
    E2VALUE,
    MUNICHRE,
    PRECISELY_BUILDING,
    PRECISELY_CRIME,
    PRECISELY_WILDFIRE_RISK
}

export enum ShowInMap {
    Filter="FILTER",
    Panel="PANEL",
    Filter_Panel="FILTER_PANEL"
}


export enum MapMarkerVisualizationMode {
    DOTS_TO_MARKER_PINS="DOTS_TO_MARKER_PINS",
    MARKER_PINS_ONLY="MARKER_PINS_ONLY",
    CLUSTERS_TO_MARKER_PINS="CLUSTERS_TO_MARKER_PINS"
}

export const MapMarkerVisualizationModeLabels: Record<MapMarkerVisualizationMode, string> = {
    [MapMarkerVisualizationMode.DOTS_TO_MARKER_PINS]: 'DOTS TO MARKER PINS',
    [MapMarkerVisualizationMode.MARKER_PINS_ONLY]: 'MARKER PINS ONLY',
    [MapMarkerVisualizationMode.CLUSTERS_TO_MARKER_PINS]: 'CLUSTERS TO MARKER PINS'
  };
